import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../store/store";
import Tooltip from "@mui/material/Tooltip";
import EventServices from "../../services/EventServices";
import { assignCurrentMember } from "../../store/currentMemberSlice";
import * as routeConfig from "../../config/routes";
import { useAppSelector } from "../../store/hooks";
import { useNavigate } from "react-router-dom";
import {
  IOrder,
  resetOrderParameters,
  setCurrentOrderId,
  storeUpdateOrder,
  assignOrderInfo,
  storeAssignOrderItem,
  storeUpdateOrderItem,
} from "../../store/orderApiSlice";
import {
  EventDetailBodyType,
  IOrderDetail,
  assignEvent,
  updateOrderDetail,
} from "../../store/eventApiSlice";
import {
  Label,
  PageLink,
  SecondaryBlueButton,
  SecondaryWhiteButton,
} from "../StyledComp/StyledComp";
import ReactModal from "react-modal";
import { FaLaptopHouse } from "react-icons/fa";
import { Alert, Button, CircularProgress } from "@mui/material";
import EventFindMember from "./EventFindMember";
import EventAddGuest from "./EventAddGuest";
import { resetSearchParameters } from "../../store/searchMemberApiSlice";
import { resetCreateBody } from "../../store/memberApiSlice";
import dayjs from "dayjs";
import { fileSave } from "browser-fs-access";
import EventMemberPaymentInfo from "./EventMemberPaymentInfo";
import OrderServices from "../../services/OrderServices";
import IMember from "../../store/memberInterfaceStruct";
import {
  IGuestOrder,
  storeAssignGuestOrderItem,
  storeResetGuestOrder,
  storeUpdateGuestOrder,
  storeUpdateGuestOrderItem,
} from "../../store/guestOrderApiSlice";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import DSBAlogo from "../../Images/DSBAlogo.png";
import FuncAttendanceReport from "../reports/FuncAttendanceReport";
import CLEAttendanceReport from "../reports/CLEAttendanceReport";
import CommissionReport from "../reports/CommissionReport";
import InvoiceServices from "../../services/InvoiceServices";
import AlertWithModal from "../utilityComponents/AlertWithModal";
import MemberServices from "../../services/MemberServices";

interface IProps {
  isEditMode?: boolean;
}
const ParticipantList: React.FC<IProps> = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const pdfRef = useRef<HTMLDivElement>(null);
  const [invoiceURL, setinvoiceURL] = useState<string>("");
  const [attendanceState, setAttendanceState] =
    useState<Record<string, boolean>>();
  const [markAttendanceModalOpen, setMarkAttendanceModalOpen] = useState(false);
  const [addGuestModelOpen, setAddGuestModalOpen] = useState(false);
  const [addMemberModelOpen, setAddMemberModalOpen] = useState(false);
  const [viewInvoiceModalOpen, setViewInvoiceModalOpen] = useState(false);
  const [
    viewFuncAttendanceReportModalOpen,
    setViewFuncAttendanceReportModalOpen,
  ] = useState(false);
  const [viewCommissionReportModalOpen, setViewCommissionReportModalOpen] =
    useState(false);
  const [
    viewCLEAttendanceReportModalOpen,
    setViewCLEAttendanceReportModalOpen,
  ] = useState(false);

  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [isDataLoading, setIsDataLoading] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");
  // const [isAttendedFlag, setIsAttendedFlag] = useState(false);
  let eventInfo = useSelector((state: RootState) => state.eventapislice.event);

  const orderInfo: IOrder = useAppSelector((store) => store.orderapislice);
  const guestOrderInfo: IGuestOrder = useAppSelector(
    (store) => store.guestOrderapislice
  );

  // const [orderInfo, setOrderInfo] = useState<IOrder>();
  const [orderInfoSetFlag, setOrderInfoSetFlag] = useState<boolean>(false);
  const [eventInfoSetFlag, setEventInfoSetFlag] = useState<boolean>(false);
  // const orderInfo = useAppSelector((store) => store.orderapislice);

  console.log("eventInfo:", eventInfo);
  console.log("orderInfo:", orderInfo);
  const roleCapabilites = useAppSelector(
    (state) => state.user.roleCapabilities
  );

  const [orderEventDetailModalOpen, setOrderEventDetailModalOpen] =
    useState<boolean>(false);
  const [guestOrderEventDetailModalOpen, setGuestOrderEventDetailModalOpen] =
    useState<boolean>(false);

  const [member, setMember] = useState<IMember>();

  useEffect(() => {
    console.log("useEffect orderInfo:", orderInfo);
    setOrderInfoSetFlag(true);
  }, [orderInfo, guestOrderInfo]);

  useEffect(() => {
    const getCurrentEvent = async (EventId: number) => {
      console.log("CALLED 2 ");
      console.log("getCurrentEvent in ParticipantList:", EventId);
      const response = await EventServices.getViewEventId(EventId);
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        console.log("getCurrentEvent in ParticipantList:", response.data.data);
        dispatch(assignEvent(response.data.data));
        console.log("Dispatched action:", response.data.data);

        // // set edit mode as false (initial value) for all participants
        // console.log("Dispatched action:", response.data.data.OrderDetail);
        // response.data.data.OrderDetail.map(
        //   (orderItem: IOrderDetail, index: number) => {
        //     console.log("orderItem.Id:", orderItem.Id);
        //     const eventDetailBodyType: EventDetailBodyType = {
        //       key: "IsAttendenceInEditMode",
        //       value: false,
        //       index: index,
        //     };
        //     dispatch(updateOrderDetail(eventDetailBodyType));
        //   }
        // );
        // console.log("AFTER MAP FUNCTION");
      } else {
        console.log("Error: Data not received");
      }
    };

    if (
      !addMemberModelOpen &&
      !orderEventDetailModalOpen &&
      !guestOrderEventDetailModalOpen &&
      !addGuestModelOpen
    ) {
      console.log("CALLED 1 ");
      getCurrentEvent(eventInfo.Id);
    }
  }, [
    addMemberModelOpen,
    orderEventDetailModalOpen,
    guestOrderEventDetailModalOpen,
    addGuestModelOpen,
    eventInfo.Id,
    dispatch,
  ]);

  const downloadReport = async () => {
    console.log("downloadReport");
    try {
      const searchParameters = {
        EventId: eventInfo.Id,
        EventType: eventInfo.EventType,
      };
      const response = await EventServices.downloadAttendenceReport(
        searchParameters
      );
      console.log("Response Data:", response.data);
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      // const fileName = "MemberReport.xlsx";
      // await fileSave(blob, { fileName:fileName,extensions: ['.xlsx'] });
      await fileSave(blob, {
        fileName: "EventReport_" + eventInfo.UniqueEventId + ".xlsx",
        extensions: [".xlsx"],
      });
    } catch (error) {
      if (error === "AbortError") {
        console.log("User aborted the download");
      } else {
        console.error("Error downloading file:", error);
      }
    }
  };

  // useEffect(() => {
  //   // if (eventInfo?.OrderDetail?.[index].DECredits === null) {
  //   const updatedEventinfo = eventInfo?.OrderDetail?.map((OrderDetailItem) => {
  //     return {
  //       ...OrderDetailItem,
  //       DECredits: OrderDetailItem.DECredits ?? eventInfo?.DECredits!,
  //     };
  //   });
  //   // const eventDetailBodyType: EventDetailBodyType = {
  //   //   key: "DECredits",
  //   //   value: eventInfo.DECredits!,
  //   //   index: 1,
  //   // };
  //   // dispatch(updateOrderDetail(eventDetailBodyType));
  // }, []);

  const isValidEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const callCreateGuestOrderAPI = async () => {
    // alert("callCreateOrderAPI");
    console.log("onSUBMIT:", guestOrderInfo);
    setIsDataLoading(true);
    const apiBody: any = guestOrderInfo;
    const response = await OrderServices.createGuestOrder(apiBody);
    dispatch(storeResetGuestOrder());
    setOrderEventDetailModalOpen(false);
    console.log("response", response);
    // alert("response received");
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      alert("Order Created successfully");
      setAddGuestModalOpen(false);
      if (
        guestOrderInfo.Email !== undefined &&
        isValidEmail(guestOrderInfo.Email!!) === true &&
        guestOrderInfo.NoInvoice === false
      ) {
        const apiBody1: any = {
          orderId: response.data.data.insertId,
          memberId: response.data.data.memberId,
          paymentStaus: 1, //invoice created
        };

        const response1 = await InvoiceServices.createOrderInvoiceSync(
          apiBody1
        );
        console.log("INVOICE response", response1.data.data);
        // console.log("INVOICE URL", response1.data.data[0].InvoiceUrl);
        console.log("INVOICE URL", response1.data.data);
        if (response1.data.data !== "NULL") {
          if (response1.data.hasErrors) {
            setShowAlertModal(true);
            setAlertTitle("Database Error");
            setAlertBody(response1.data.errors[0].sqlMessage);
            return;
          }
          setinvoiceURL(response1.data.data);
          setViewInvoiceModalOpen(true);
          console.log("invoice url:", response1.data.data);
          setinvoiceURL(response1.data.data);
          setOrderEventDetailModalOpen(false);
          setViewInvoiceModalOpen(true);
          console.log("member:", member);
        }
      }
      setIsDataLoading(false);
      // dispatch(resetOrderParameters());  I am doing this in useEffect
      // navigate("/order", { replace: true });
      // dispatch(changeCurrentMemberMenu(screenConfig.viewOrder));
      // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));

      dispatch(
        storeUpdateOrder({
          key: "TransactionAmount",
          value: 0,
        })
      );

      // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
      // navigate("/member", { replace: false });
      // dispatch(changeCurrentMemberMenu(screenConfig.eventList));
      //  dispatch(screenChange("Events"));
    } else {
      alert(response.data.errors);
      console.log("error");
      setIsDataLoading(false);
    }
  };

  const viewMember = async (data: any) => {
    if (
      !roleCapabilites.some((obj: any) =>
        Object.values(obj).includes("members.view")
      )
    ) {
      alert("No Access");
      return;
    }
    console.log(data);
    console.log(data.Id);
    // getMemberDetail(data.MemberId)
    console.log("getmemberdetail  clicked **************");
    const response = await EventServices.getMember(data.MemberId);
    console.log("EventServices.getMember:", response);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      dispatch(assignCurrentMember(response.data.data[0]));
      navigate(routeConfig.MEMBER_DETAIL_URL, { replace: false });
    } else {
      alert(response.data.errors[0]);
    }
  };

  const ViewOrder = async (data: any) => {
    if (
      !roleCapabilites.some((obj: any) =>
        Object.values(obj).includes("orders.view")
      )
    ) {
      alert("No Access");
      return;
    }
    console.log(data);
    console.log(data.Id);
    console.log("getmemberdetail  clicked **************");
    dispatch(setCurrentOrderId(Number(data.OrderId)));
    navigate(routeConfig.ORDER_DETAIL_URL, { replace: false });
  };

  const updateModerators = async (rowdata: any) => {
    const data = {
      OrderId: rowdata.OrderId,
      EventId: rowdata.EventId,
      EventType: eventInfo.EventType,
    };
    console.log("Request data:", data);
    const response = await EventServices.updateModerator(data);
    console.log("EventServices.updateModerator:", response);

    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      console.log("Data update successful:", response.data.data);
      dispatch(assignEvent(response.data.data));
    } else {
      console.log("Error during data update.");
    }
  };

  const updateSpeakers = async (rowdata: any) => {
    const data = {
      OrderId: rowdata.OrderId,
      EventId: rowdata.EventId,
      EventType: eventInfo.EventType,
    };
    console.log("Request data:", data);
    const response = await EventServices.updateSpeaker(data);
    console.log("EventServices.updateSpeaker:", response);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      console.log("Data update successful:", response.data.data);
      dispatch(assignEvent(response.data.data));
    } else {
      console.log("Error during data update.");
    }
  };

  const updateAttendees = async (rowdata: any) => {
    const data = {
      OrderId: rowdata.OrderId,
      EventId: rowdata.EventId,
      EventType: eventInfo.EventType,
    };
    console.log("Request data:", data);
    const response = await EventServices.updateAttendee(data);
    console.log("EventServices.updateAttendee:", response);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      console.log("Data update successful:", response.data.data);
      // getCurrentEvent();
      dispatch(assignEvent(response.data.data));
    } else {
      console.log("Error during data update.");
    }
  };

  const markAttendences = async (rowdata: any) => {
    const data = {
      OrderId: rowdata.OrderId,
      EventId: rowdata.EventId,
      EventType: eventInfo.EventType,
    };
    console.log("Request data:", data);
    const response = await EventServices.markAttendence(data);
    console.log("EventServices.markAttendence:", response);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      console.log("Data update successful:", response.data.data);
      // getCurrentEvent();
      dispatch(assignEvent(response.data.data));
    } else {
      console.log("Error during data update.");
    }
  };

  const unmarkAttendences = async (rowdata: any) => {
    const data = {
      OrderId: rowdata.OrderId,
      EventId: rowdata.EventId,
      EventType: eventInfo.EventType,
    };
    console.log("Request data:", data);
    const response = await EventServices.unmarkAttendence(data);
    console.log("EventServices.unmarkAttendence:", response);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      console.log("Data update successful:", response.data.data);
      // getCurrentEvent();
      dispatch(assignEvent(response.data.data));
    } else {
      console.log("Error during data update.");
    }
  };

  const handleCheck = (orderDetailItem: any) => {
    const data = {
      OrderId: orderDetailItem.OrderId,
      EventId: orderDetailItem.EventId,
      EventType: eventInfo.EventType,
    };

    setAttendanceState((prevAttendanceState) => {
      const newState = { ...prevAttendanceState };
      const key = JSON.stringify(data);
      newState[key] = !newState[key];

      if (newState[key]) {
        markAttendences(orderDetailItem);
        console.log("Marking attendance:", data);
      } else {
        unmarkAttendences(orderDetailItem);
        console.log("unMarking attendance:", data);
      }
      return newState;
    });
  };

  const handleCancel = () => {
    setOrderEventDetailModalOpen(false);
    setMarkAttendanceModalOpen(false);
    setAddMemberModalOpen(false);
    setAddGuestModalOpen(false);
    dispatch(resetSearchParameters());
    dispatch(resetCreateBody());
    dispatch(storeResetGuestOrder());
  };

  const updateAttendance = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    console.log("updateAttendance CALLED");
    console.log("e.target.name:", e.target.name);
    // switch (e.target.name) {
    //   case "DECredits":
    console.log("DECredits:", e.target.value, ":", index);
    const eventDetailBodyType: EventDetailBodyType = {
      key: e.target.name,
      value: e.target.value,
      index: index,
    };
    dispatch(updateOrderDetail(eventDetailBodyType));
    //   break;

    // default:
    //   break;
    // }
  };

  const submitAttendance = async (index: number) => {
    console.log("event1:", eventInfo?.OrderDetail?.[index]);

    // turning off  edit mode IsAttendenceInEditMode
    const eventDetailBodyType2: EventDetailBodyType = {
      key: "IsAttendenceInEditMode",
      value: 0,
      index: index,
    };
    dispatch(updateOrderDetail(eventDetailBodyType2));

    // const eventDetailBodyType1: EventDetailBodyType = {
    //   key: "IsAttendenceUpdated",
    //   value: 1,
    //   index: index,
    // };
    // dispatch(updateOrderDetail(eventDetailBodyType1));

    // if (eventInfo?.OrderDetail?.[index].IsAttendenceUpdated === 0) {
    //   alert("Please select attendance");
    //   return;
    // }

    // should improve this after demo
    const updatedEventinfo = eventInfo?.OrderDetail?.map(
      (OrderDetailItem: any) => {
        return {
          ...OrderDetailItem,
          DECredits: OrderDetailItem.DECredits ?? eventInfo?.DECredits!,
          DEEnchEthics:
            OrderDetailItem.DEEnchEthics ?? eventInfo?.DEEnchEthics!,
          PACredits: OrderDetailItem.PACredits ?? eventInfo?.PACredits!,
          PAEthics: OrderDetailItem.PAEthics ?? eventInfo?.PAEthics!,
          NJCredits: OrderDetailItem.NJCredits ?? eventInfo?.NJCredits!,
          NJEthics: OrderDetailItem.NJEthics ?? eventInfo?.NJEthics!,
        };
      }
    );

    let submitOrderDetail: IOrderDetail = updatedEventinfo?.[index]!;
    console.log("event2:", submitOrderDetail);
    const response = await EventServices.creditAttendence(submitOrderDetail);

    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      console.log("EventServices.creditAttendence:", response);
      
      // Update the Redux state with the saved values to reflect in the UI
      const eventDetailBodyType: EventDetailBodyType = {
        key: "DECredits",
        value: submitOrderDetail.DECredits ?? 0,
        index: index,
      };
      dispatch(updateOrderDetail(eventDetailBodyType));
      
      const eventDetailBodyType2: EventDetailBodyType = {
        key: "DEEnchEthics",
        value: submitOrderDetail.DEEnchEthics ?? 0,
        index: index,
      };
      dispatch(updateOrderDetail(eventDetailBodyType2));
      
      const eventDetailBodyType3: EventDetailBodyType = {
        key: "PACredits",
        value: submitOrderDetail.PACredits ?? 0,
        index: index,
      };
      dispatch(updateOrderDetail(eventDetailBodyType3));
      
      const eventDetailBodyType4: EventDetailBodyType = {
        key: "PAEthics",
        value: submitOrderDetail.PAEthics ?? 0,
        index: index,
      };
      dispatch(updateOrderDetail(eventDetailBodyType4));
      
      const eventDetailBodyType5: EventDetailBodyType = {
        key: "NJCredits",
        value: submitOrderDetail.NJCredits ?? 0,
        index: index,
      };
      dispatch(updateOrderDetail(eventDetailBodyType5));
      
      const eventDetailBodyType6: EventDetailBodyType = {
        key: "NJEthics",
        value: submitOrderDetail.NJEthics ?? 0,
        index: index,
      };
      dispatch(updateOrderDetail(eventDetailBodyType6));
    } else {
      alert(response.data.errors[0]);
    }
  };

  const setIsAttended = (
    e: React.ChangeEvent<HTMLInputElement>,
    attendanceStatus: number,
    index: number
  ) => {
    console.log(
      "setIsAttended CALLED-attendanceStatus/index",
      attendanceStatus,
      "-",
      index
    );
    const eventDetailBodyType: EventDetailBodyType = {
      key: "IsAttended",
      value: attendanceStatus,
      index: index,
    };
    // setIsAttendedFlag(true);
    dispatch(updateOrderDetail(eventDetailBodyType));

    const eventDetailBodyType1: EventDetailBodyType = {
      key: "IsAttendenceUpdated",
      value: 1,
      index: index,
    };
    dispatch(updateOrderDetail(eventDetailBodyType1));

    const eventDetailBodyType2: EventDetailBodyType = {
      key: "IsAttendenceInEditMode",
      value: 1,
      index: index,
    };
    dispatch(updateOrderDetail(eventDetailBodyType2));
  };

  // const callOrderAPI = async () => {
  //   // setModalOpen(false);
  //   const apiBody: any = orderInfo;
  //   const response = await OrderServices.createOrder(apiBody);
  //   dispatch(resetOrderParameters());
  //   console.log("response", response);
  //   if (response.data.data != null) {
  //     alert("Order Created successfully");
  //     // dispatch(resetOrderParameters());  I am doing this in useEffect
  //     // navigate("/order", { replace: true });
  //     // dispatch(changeCurrentMemberMenu(screenConfig.viewOrder));
  //     // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));

  //     dispatch(
  //       storeUpdateOrder({
  //         key: "TransactionAmount",
  //         value: 0,
  //       })
  //     );

  //     // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
  //     // navigate("/member", { replace: false });
  //     // dispatch(changeCurrentMemberMenu(screenConfig.eventList));
  //     //  dispatch(screenChange("Events"));
  //   } else {
  //     alert(response.data.errors);
  //     console.log("error");
  //   }
  // };

  const openOrderEventDetail = (
    event: React.MouseEvent<HTMLElement>,
    member: IMember
  ) => {
    setOrderEventDetailModalOpen(true);
    console.log("EventFindMember Select:", member.Id);
    setMember(member);
  };

  const callUpdateOrderAPI = async () => {
    // alert("callUpdateOrderAPI");
    if (orderInfoSetFlag === true) {
      console.log("onSUBMIT:", orderInfo);
      const apiBody: any = orderInfo;
      const response = await OrderServices.updateOrder(apiBody);
      dispatch(storeResetGuestOrder());
      setOrderEventDetailModalOpen(false);
      console.log("OrderServices.updateOrder-response", response);
      // alert("response received");
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        alert("Order Updated successfully");
        setOrderEventDetailModalOpen(false);
        // dispatch(resetOrderParameters());  I am doing this in useEffect
        // navigate("/order", { replace: true });
        // dispatch(changeCurrentMemberMenu(screenConfig.viewOrder));
        // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));

        dispatch(
          storeUpdateOrder({
            key: "TransactionAmount",
            value: 0,
          })
        );

        // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
        // navigate("/member", { replace: false });
        // dispatch(changeCurrentMemberMenu(screenConfig.eventList));
        //  dispatch(screenChange("Events"));
      } else {
        alert(response.data.errors);
        console.log("error");
      }
    }
  };

  const handleSendInvoice = async () => {
    if (
      member &&
      member.PrimaryAddress &&
      member.PrimaryAddress.Email === null &&
      member.PublishedAddress &&
      member.PublishedAddress.Email === null
    ) {
      alert("Email ID missing");
      return;
    }
    let body = {
      InvoiceLink: invoiceURL,
      FirstName: member && member.FirstName,
      LastName: member && member.LastName,
      Esquired: member && member.Esquire,
      MemberEmail:
        member && member.PrimaryAddress && member && member.PrimaryAddress.Email
          ? member && member.PrimaryAddress.Email
          : member &&
            member.PublishedAddress &&
            member &&
            member.PublishedAddress.Email,
    };

    const response = await MemberServices.sendGuestCLEReceiptEmailToMember(
      body
    );
    console.log("response...", response.data.data);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      console.log("Success");
      console.log("response1...", response.data.data);
      alert("Mail Sent Successfully");
      // navigate("/member", { replace: false });
    } else {
      console.log("error", response);
    }
    setViewInvoiceModalOpen(false);
  };

  const callUpdateGuestOrderAPI = async () => {
    // alert("callUpdateOrderAPI");
    if (orderInfoSetFlag === true) {
      console.log("guest onSUBMIT:", guestOrderInfo);
      const apiBody: any = guestOrderInfo;
      const response = await OrderServices.updateOrder(apiBody);
      dispatch(resetOrderParameters());
      setGuestOrderEventDetailModalOpen(false);
      console.log("Guest OrderServices.updateOrder-response", response);
      // alert("response received");
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        alert("Guest Order Update successfully");
        setGuestOrderEventDetailModalOpen(false);
        // dispatch(resetOrderParameters());  I am doing this in useEffect
        // navigate("/order", { replace: true });
        // dispatch(changeCurrentMemberMenu(screenConfig.viewOrder));
        // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));

        dispatch(
          storeUpdateGuestOrder({
            key: "TransactionAmount",
            value: 0,
          })
        );

        // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
        // navigate("/member", { replace: false });
        // dispatch(changeCurrentMemberMenu(screenConfig.eventList));
        //  dispatch(screenChange("Events"));
      } else {
        alert(response.data.errors);
        console.log("error");
      }
    }
  };

  const callCertificateAPI = async (eventData: any, OrderDetail: any) => {
    var data = {
      FirstName: OrderDetail["FirstName"] + " " + OrderDetail["LastName"],
      Title: OrderDetail["Title"],
      BarId: OrderDetail["BarId"],
      EventName: eventData.EventName,
      DECredits: eventData.DECredits === null || eventData.DECredits === undefined ? "" : eventData.DECredits,
      DEEnchEthics: eventData.DEEnchEthics === null || eventData.DEEnchEthics === undefined ? "" : eventData.DEEnchEthics,
      DateCompleted: OrderDetail["DateCompleted"].split("T")[0],
      Id: eventData.UniqueEventId,
      OrderId: OrderDetail["OrderId"],
    };
    const response1 = await InvoiceServices.createVideoCertificateSync(data);
    console.log("INVOICE response", response1.data.data);
    // console.log("INVOICE URL", response1.data.data[0].InvoiceUrl);
    console.log("INVOICE URL", response1.data.data);
    if (response1.data.data !== "NULL") {
      if (response1.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response1.data.errors[0].sqlMessage);
        return;
      }
      window.open(response1.data.data, "_blank");
    }
  };

  const getOrder = async (OrderId: number, isGuest?: boolean) => {
    setOrderInfoSetFlag(false);
    const response = await OrderServices.getOrder(OrderId);
    console.log("OrderServices.getOrder:", response.data.data);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      console.log("Success:", response.data.data);
      // setOrderInfo(response.data.data);

      // update order apli slice
      if (!isGuest) {
        if (
          response.data.data?.OrderId !== undefined ||
          response.data.data?.OrderId !== null
        ) {
          dispatch(
            storeUpdateOrder({
              key: "OrderId",
              value: response.data.data?.OrderId!,
            })
          );
        }

        if (
          response.data.data?.Comments !== undefined ||
          response.data.data?.Comments !== null
        ) {
          dispatch(
            storeUpdateOrder({
              key: "Comments",
              value: response.data.data?.Comments!,
            })
          );
          //console.log("participant List:", response.data.data?.MemberId!);
        }

        if (
          response.data.data?.MemberId !== undefined ||
          response.data.data?.MemberId !== null
        ) {
          dispatch(
            storeUpdateOrder({
              key: "MemberId",
              value: response.data.data?.MemberId!,
            })
          );
          console.log("participant List:", response.data.data?.MemberId!);
        }

        if (
          response.data.data?.TransactionType !== undefined ||
          response.data.data?.TransactionType !== null
        ) {
          dispatch(
            storeUpdateOrder({
              key: "TransactionType",
              value: response.data.data?.TransactionType!,
            })
          );
        }

        if (
          response.data.data?.CheckNumber !== undefined ||
          response.data.data?.CheckNumber !== null
        ) {
          dispatch(
            storeUpdateOrder({
              key: "CheckNumber",
              value: response.data.data?.CheckNumber!,
            })
          );
        }

        if (
          response.data.data?.LateFee !== undefined ||
          response.data.data?.LateFee !== null
        ) {
          dispatch(
            storeUpdateOrder({
              key: "LateFee",
              value: response.data.data?.LateFee!,
            })
          );
        }

        if (
          response.data.data?.AuthCode !== undefined ||
          response.data.data?.AuthCode !== null
        ) {
          dispatch(
            storeUpdateOrder({
              key: "AuthCode",
              value: response.data.data?.AuthCode!,
            })
          );
        }

        if (
          response.data.data?.SeminarOrder &&
          response.data.data?.SeminarOrder.length > 0
        ) {
          console.log("storeAssignOrderItem CALLED SeminarOrder");
          dispatch(
            storeAssignOrderItem({
              key: "Orders",
              value: response.data.data?.SeminarOrder[0]!,
            })
          );
        } else if (
          response.data.data?.FunctionOrder &&
          response.data.data?.FunctionOrder.length > 0
        ) {
          console.log("storeAssignOrderItem CALLED FunctionOrder");
          dispatch(
            storeAssignOrderItem({
              key: "Orders",
              value: response.data.data?.FunctionOrder[0]!,
            })
          );
        } else if (
          response.data.data?.VideoOrder &&
          response.data.data?.VideoOrder.length > 0
        ) {
          console.log("storeAssignOrderItem CALLED VideoOrder");
          dispatch(
            storeAssignOrderItem({
              key: "Orders",
              value: response.data.data?.VideoOrder[0]!,
            })
          );
        }

        if (eventInfo.EventType) {
          dispatch(
            storeUpdateOrderItem({
              key: "OrderType",
              value: eventInfo.EventType!,
            })
          );
        }

        if (response.data.data?.TransactionAmount) {
          // setTransactionAmount(response.data.data?.TransactionAmount!);
          dispatch(
            storeUpdateOrder({
              key: "TransactionAmount",
              value: response.data.data?.TransactionAmount!,
            })
          );
        }

        if (response.data.data?.TotalAmount) {
          dispatch(
            storeUpdateOrder({
              key: "TotalAmount",
              value: response.data.data?.TotalAmount,
            })
          );
        }

        //if (response.data.data?.AmountPaid) {
        dispatch(
          storeUpdateOrder({
            key: "AmountPaid",
            value: response.data.data?.AmountPaid,
          })
        );
        // }

        dispatch(
          storeUpdateOrder({
            key: "CouponAmount",
            value: response.data.data?.CouponAmount,
          })
        );

        if (dayjs(response.data.data?.DatePaid).isValid()) {
          dispatch(
            storeUpdateOrder({
              key: "DatePaid",
              value: dayjs(response.data.data?.DatePaid!, "YYYY-MM-DD").format(
                "YYYY-MM-DD"
              ),
            })
          );
          // setDatePaid(dayjs(response.data.data?.DatePaid!, "YYYY-MM-DD"));
        }
      } else {
        // updating guest order info

        dispatch(
          storeUpdateGuestOrder({
            key: "CouponAmount",
            value: response.data.data?.CouponAmount,
          })
        );

        if (
          response.data.data?.Comments !== undefined ||
          response.data.data?.Comments !== null
        ) {
          dispatch(
            storeUpdateGuestOrder({
              key: "Comments",
              value: response.data.data?.Comments!,
            })
          );
          //console.log("participant List:", response.data.data?.MemberId!);
        }

        if (response.data.data?.FirstName) {
          dispatch(
            storeUpdateGuestOrder({
              key: "IsGuest",
              value: 1,
            })
          );
        }

        if (response.data.data?.FirstName) {
          dispatch(
            storeUpdateGuestOrder({
              key: "FirstName",
              value: response.data.data?.FirstName,
            })
          );
        }

        if (response.data.data?.LastName) {
          dispatch(
            storeUpdateGuestOrder({
              key: "LastName",
              value: response.data.data?.LastName,
            })
          );
        }

        if (response.data.data?.Gender) {
          dispatch(
            storeUpdateGuestOrder({
              key: "Gender",
              value: response.data.data?.Gender,
            })
          );
        }

        if (response.data.data?.PhoneNumber) {
          dispatch(
            storeUpdateGuestOrder({
              key: "PhoneNumber",
              value: response.data.data?.PhoneNumber,
            })
          );
        }

        if (response.data.data?.Email) {
          dispatch(
            storeUpdateGuestOrder({
              key: "Email",
              value: response.data.data?.Email,
            })
          );
        }

        if (response.data.data?.Address1) {
          dispatch(
            storeUpdateGuestOrder({
              key: "Address1",
              value: response.data.data?.Address1,
            })
          );
        }

        if (response.data.data?.Address2) {
          dispatch(
            storeUpdateGuestOrder({
              key: "Address2",
              value: response.data.data?.Address2,
            })
          );
        }

        if (response.data.data?.City) {
          dispatch(
            storeUpdateGuestOrder({
              key: "City",
              value: response.data.data?.City,
            })
          );
        }

        if (response.data.data?.State) {
          dispatch(
            storeUpdateGuestOrder({
              key: "State",
              value: response.data.data?.State,
            })
          );
        }

        if (response.data.data?.Zipcode) {
          dispatch(
            storeUpdateGuestOrder({
              key: "Zipcode",
              value: response.data.data?.Zipcode,
            })
          );
        }

        if (response.data.data?.OrderId) {
          dispatch(
            storeUpdateGuestOrder({
              key: "OrderId",
              value: response.data.data?.OrderId!,
            })
          );
        }

        if (response.data.data?.MemberId) {
          dispatch(
            storeUpdateGuestOrder({
              key: "MemberId",
              value: response.data.data?.MemberId!,
            })
          );
          console.log("participant List:", response.data.data?.MemberId!);
        }

        if (response.data.data?.TransactionType) {
          dispatch(
            storeUpdateGuestOrder({
              key: "TransactionType",
              value: response.data.data?.TransactionType!,
            })
          );
        }

        if (response.data.data?.CheckNumber) {
          dispatch(
            storeUpdateGuestOrder({
              key: "CheckNumber",
              value: response.data.data?.CheckNumber!,
            })
          );
        }

        if (response.data.data?.LateFee) {
          dispatch(
            storeUpdateGuestOrder({
              key: "LateFee",
              value: response.data.data?.LateFee!,
            })
          );
        }

        if (response.data.data?.AuthCode) {
          dispatch(
            storeUpdateGuestOrder({
              key: "AuthCode",
              value: response.data.data?.AuthCode!,
            })
          );
        }

        if (response.data.data?.Comments) {
          dispatch(
            storeUpdateGuestOrder({
              key: "Comments",
              value: response.data.data?.Comments,
            })
          );
        }

        if (response.data.data?.TotalAmount) {
          dispatch(
            storeUpdateGuestOrder({
              key: "TotalAmount",
              value: response.data.data?.TotalAmount,
            })
          );
        }

        if (response.data.data?.AmountPaid) {
          dispatch(
            storeUpdateGuestOrder({
              key: "AmountPaid",
              value: response.data.data?.AmountPaid,
            })
          );
        }

        if (
          response.data.data?.SeminarOrder &&
          response.data.data?.SeminarOrder.length > 0
        ) {
          console.log("storeAssignOrderItem CALLED SeminarOrder");
          dispatch(
            storeAssignGuestOrderItem({
              key: "Orders",
              value: response.data.data?.SeminarOrder[0]!,
            })
          );
        } else if (
          response.data.data?.FunctionOrder &&
          response.data.data?.FunctionOrder.length > 0
        ) {
          console.log("storeAssignOrderItem CALLED FunctionOrder");
          dispatch(
            storeAssignGuestOrderItem({
              key: "Orders",
              value: response.data.data?.FunctionOrder[0]!,
            })
          );
        } else if (
          response.data.data?.VideoOrder &&
          response.data.data?.VideoOrder.length > 0
        ) {
          console.log("storeAssignOrderItem CALLED VideoOrder");
          dispatch(
            storeAssignGuestOrderItem({
              key: "Orders",
              value: response.data.data?.VideoOrder[0]!,
            })
          );
        }

        if (eventInfo.EventType) {
          dispatch(
            storeUpdateGuestOrderItem({
              key: "OrderType",
              value: eventInfo.EventType!,
            })
          );
        }

        if (response.data.data?.TransactionAmount) {
          // setTransactionAmount(response.data.data?.TransactionAmount!);
          dispatch(
            storeUpdateGuestOrder({
              key: "TransactionAmount",
              value: response.data.data?.TransactionAmount!,
            })
          );
        }

        if (dayjs(response.data.data?.DatePaid).isValid()) {
          dispatch(
            storeUpdateGuestOrder({
              key: "DatePaid",
              value: dayjs(response.data.data?.DatePaid!, "YYYY-MM-DD").format(
                "YYYY-MM-DD"
              ),
            })
          );
          // setDatePaid(dayjs(response.data.data?.DatePaid!, "YYYY-MM-DD"));
        }
      }
    } else {
    }
  };

  // const downloadPDF = () => {
  //   const input = pdfRef.current;

  //   input &&
  //     html2canvas(input).then((canvas) => {
  //       const imgData = canvas.toDataURL("image/png");
  //       const pdf = new jsPDF("p", "mm", "a4", true);
  //       const pdfWidth = pdf.internal.pageSize.getWidth();
  //       const pdfHeight = pdf.internal.pageSize.getHeight();
  //       const imgWidth = canvas.width;
  //       const imgHeight = canvas.height;
  //       // const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
  //       const ratio = pdfWidth / imgWidth;
  //       const imgScaledHeight = imgHeight * ratio;
  //       let heightLeft = imgScaledHeight;
  //       let position = 0;

  //       const imgX = (pdfWidth - imgWidth * ratio) / 2;
  //       const imgY = 30;
  //       console.log("imgX:", imgX, "-pdfWidth:", pdfWidth);
  //       console.log("imgY:", imgX, "-pdfHeight:", pdfHeight);
  //       pdf.addImage(
  //         imgData,
  //         "PNG",
  //         // imgX,
  //         // imgY,
  //         0,
  //         position,
  //         // imgWidth * ratio,
  //         // imgHeight * ratio
  //         pdfWidth,
  //         imgScaledHeight - imgY
  //       );

  //       heightLeft -= pdfHeight;

  //       while (heightLeft > 0) {
  //         position = heightLeft - imgScaledHeight + imgY;
  //         pdf.addPage();
  //         pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgScaledHeight);
  //         heightLeft -= pdfHeight;
  //       }

  //       pdf.save("invoice.pdf");
  //     });
  // };
  return (
    <>
      {/* <SecondaryWhiteButton
        className="button-wrapper"
        type="button"
        style={{
          marginRight: ".5rem",
          marginLeft: ".5rem",
        }}
        onClick={() => downloadPDF()}
      >
        <span style={{ fontWeight: "500" }}>print</span>
      </SecondaryWhiteButton> */}
      <div className="section-box">
        <div className="horizontal-wrapper-spacebetween">
          <h3 className="section-heading">Participants Information</h3>
          <div
            className="horizontal-wrapper-rightaligned"
            style={{ width: "auto", marginLeft: "0px", marginRight: "0px" }}
          >
            {eventInfo.EventType !== "Video" ? (
              <>
                <SecondaryWhiteButton
                  className="button-wrapper"
                  type="button"
                  style={{
                    marginRight: ".5rem",
                    marginLeft: ".5rem",
                  }}
                  onClick={() => setAddGuestModalOpen(true)}
                >
                  <span style={{ fontWeight: "500" }}> Add Guest</span>
                </SecondaryWhiteButton>
                <SecondaryWhiteButton
                  className="button-wrapper"
                  type="button"
                  style={{
                    marginRight: "0.5rem",
                    marginLeft: "0.5rem",
                  }}
                  onClick={() => setAddMemberModalOpen(true)}
                >
                  <span style={{ fontWeight: "500" }}> Add Member</span>
                </SecondaryWhiteButton>{" "}
              </>
            ) : (
              <></>
            )}
            {eventInfo.EventType !== "Video" ? (
              <>
                <SecondaryWhiteButton
                  className="button-wrapper"
                  type="button"
                  style={{
                    marginRight: "0.5rem",
                    marginLeft: "0.5rem",
                  }}
                  onClick={() => {
                    if (
                      dayjs(eventInfo.StartDateTime).isAfter(dayjs(), "day")
                    ) {
                      alert(
                        "This event is not started yet. Please try once the event is over."
                      );
                      return;
                    }
                    setMarkAttendanceModalOpen(true);
                  }}
                >
                  <span style={{ fontWeight: "500" }}> Mark Attendance</span>
                </SecondaryWhiteButton>
              </>
            ) : (
              <></>
            )}
            {/* DOWNLOAD REPORT */}
            {/* {eventInfo &&
            eventInfo.OrderDetail &&
            eventInfo.OrderDetail.length > 0 ? (
              <SecondaryWhiteButton
                className="button-wrapper"
                type="button"
                style={{
                  marginRight: "0.5rem",
                  marginLeft: "0.5rem",
                }}
                onClick={downloadReport}
              >
                <span style={{ fontWeight: "500" }}> Download Report </span>
              </SecondaryWhiteButton>
            ) : (
              <></>
            )} */}

            {/* COMMISSION REPORT */}
            {eventInfo ? (
              <SecondaryWhiteButton
                className="button-wrapper"
                type="button"
                style={{
                  marginRight: "0.5rem",
                  marginLeft: "0.5rem",
                }}
                onClick={() => setViewCommissionReportModalOpen(true)}
              >
                <span style={{ fontWeight: "500" }}> Commission Report </span>
              </SecondaryWhiteButton>
            ) : (
              <></>
            )}

            {/* FUNC ATTENDANCE REPORT */}
            {eventInfo && eventInfo.EventType === "Function" ? (
              <SecondaryWhiteButton
                className="button-wrapper"
                type="button"
                style={{
                  marginRight: "0.5rem",
                  marginLeft: "0.5rem",
                }}
                onClick={() => setViewFuncAttendanceReportModalOpen(true)}
              >
                <span style={{ fontWeight: "500" }}>
                  {" "}
                  Func Attendance Report{" "}
                </span>
              </SecondaryWhiteButton>
            ) : (
              <></>
            )}

            {/* CLE ATTENDANCE REPORT */}
            {eventInfo && eventInfo.EventType === "Seminar" ? (
              <SecondaryWhiteButton
                className="button-wrapper"
                type="button"
                style={{
                  marginRight: "0.5rem",
                  marginLeft: "0.5rem",
                }}
                onClick={() => setViewCLEAttendanceReportModalOpen(true)}
              >
                <span style={{ fontWeight: "500" }}>CLE Attendance Report</span>
              </SecondaryWhiteButton>
            ) : (
              <></>
            )}
          </div>
        </div>
        {eventInfo.OrderDetail != null && eventInfo.OrderDetail.length > 0 ? (
          <div ref={pdfRef}>
            <table className="eventlist-table ">
              <thead className="table-border">
                <tr>
                  {eventInfo.EventType === "Video" ? (
                    <>
                      <th className="table-size">Order Id</th>
                      <th className="table-size">Name</th>
                      <th className="table-size">LastName</th>
                      <th className="table-size">Bar ID</th>
                      <th className="table-size">Completed Date</th>
                      <th className="table-size">MemberType</th>
                      <th className="table-size">Action </th>
                    </>
                  ) : (
                    <>
                      <th className="table-size" style={{ width: "100px" }}>
                        Order ID
                      </th>
                      <th className="table-size">Name</th>
                      <th className="table-size">Bar ID</th>
                      {eventInfo.EventType === "Seminar" ? (
                        <th className="table-size">Email</th>
                      ) : (
                        <></>
                      )}
                      <th className="table-size">Participant Type</th>
                      <th className="table-size">MemberType</th>
                      <th className="table-size">Location</th>

                      {eventInfo.EventType === "Seminar" ? (
                        <>
                          <th className="table-size">Cost Name</th>
                          <th className="table-size">Payment Status</th>
                        </>
                      ) : (
                        <></>
                      )}
                      {/* <th>Cost</th> */}
                      <th>Action </th>
                      {/* <th>Attendence</th> */}
                    </>
                  )}
                </tr>
              </thead>

              <tbody className="table-border">
                {eventInfo.OrderDetail.map((orderDetailItem) => (
                  <tr key={orderDetailItem.Id}>
                    {eventInfo.EventType === "Video" ? (
                      <>
                        {/* <td>{orderDetailItem.OrderId}</td> */}
                        <td>
                          <Tooltip title="View Order" arrow>
                            <span
                              className="cursor-pointer"
                              onClick={() => ViewOrder(orderDetailItem)}
                            >
                              {orderDetailItem.OrderId}
                            </span>
                          </Tooltip>
                        </td>
                        <td>
                          <Tooltip title="View Profile" arrow>
                            <span
                              className="cursor-pointer"
                              onClick={() => viewMember(orderDetailItem)}
                            >
                              {orderDetailItem.FirstName}
                            </span>
                          </Tooltip>
                        </td>
                        <td>
                          <Tooltip title="View Profile" arrow>
                            <span
                              className="cursor-pointer"
                              onClick={() => viewMember(orderDetailItem)}
                            >
                              {orderDetailItem.LastName}
                            </span>
                          </Tooltip>
                        </td>
                        <td>
                          <Tooltip title="View Profile" arrow>
                            <span
                              className="cursor-pointer"
                              onClick={() => viewMember(orderDetailItem)}
                            >
                              {orderDetailItem.BarId}
                            </span>
                          </Tooltip>
                        </td>
                        <td>
                          {eventInfo.EventType === "Video"
                            ? orderDetailItem.DateCompleted == null
                              ? ""
                              : dayjs(orderDetailItem.DateCompleted).format(
                                  "YYYY-MM-DD"
                                )
                            : orderDetailItem.ParticipantType}
                        </td>
                        <td>{orderDetailItem.IsGuest ? "Guest" : "Member"}</td>
                        <td>
                          <span
                            className="cursor-pointer"
                            onClick={() => {
                              if (!orderDetailItem.IsGuest) {
                                console.log(
                                  "orderDetailItem:",
                                  orderDetailItem
                                );
                                setOrderEventDetailModalOpen(true);
                                if (orderDetailItem.OrderId) {
                                  getOrder(orderDetailItem.OrderId as number);
                                }
                              } else {
                                console.log(
                                  "in guestOrderDetailItem:",
                                  orderDetailItem
                                );
                                setGuestOrderEventDetailModalOpen(true);
                                if (
                                  orderDetailItem.OrderId &&
                                  orderDetailItem.IsGuest
                                ) {
                                  getOrder(
                                    orderDetailItem.OrderId as number,
                                    orderDetailItem.IsGuest
                                  );
                                }
                              }
                            }}
                          >
                            Edit
                          </span>
                          <>
                            {eventInfo.EventType === "Video" ? (
                              orderDetailItem.DateCompleted == null ? (
                                ""
                              ) : (
                                <span
                                  className="cursor-pointer"
                                  onClick={() =>
                                    callCertificateAPI(
                                      eventInfo,
                                      orderDetailItem
                                    )
                                  }
                                >
                                  {" "}
                                  / Certificate{" "}
                                </span>
                              )
                            ) : (
                              orderDetailItem.ParticipantType
                            )}
                          </>
                        </td>
                      </>
                    ) : (
                      <>
                        {/* <td>{orderDetailItem.OrderId}</td> */}
                        <td>
                          <Tooltip title="View Order" arrow>
                            <span
                              className="cursor-pointer"
                              onClick={() => ViewOrder(orderDetailItem)}
                            >
                              {orderDetailItem.OrderId}
                            </span>
                          </Tooltip>
                        </td>
                        <td>
                          <Tooltip title="View Profile" arrow>
                            <span
                              className="cursor-pointer"
                              onClick={() => viewMember(orderDetailItem)}
                            >
                              {orderDetailItem.FirstName +
                                " " +
                                orderDetailItem.LastName}
                            </span>
                          </Tooltip>
                        </td>
                        <td>
                          <Tooltip title="View Profile" arrow>
                            <span
                              className="cursor-pointer"
                              onClick={() => viewMember(orderDetailItem)}
                            >
                              {orderDetailItem.BarId}
                            </span>
                          </Tooltip>
                        </td>
                        {eventInfo.EventType === "Seminar" ? (
                          <td>{orderDetailItem.Email}</td>
                        ) : (
                          <></>
                        )}
                        <td>{orderDetailItem.ParticipantType}</td>
                        <td>{orderDetailItem.IsGuest ? "Guest" : "Member"}</td>
                        <td>{orderDetailItem.Location ?? "-"}</td>

                        {eventInfo.EventType === "Seminar" ? (
                          <>
                            <td>{orderDetailItem.Cost}</td>
                            <td className="table-size">
                              {orderDetailItem.ParticipantType === "Speaker" ||
                              orderDetailItem.ParticipantType === "Moderator"
                                ? "-"
                                : (orderDetailItem.AmountPaid ?? 0) +
                                    (orderDetailItem.CouponAmount ?? 0) ===
                                  0
                                ? "Pending"
                                : orderDetailItem.TotalAmount == null ||
                                  (orderDetailItem.AmountPaid ?? 0) +
                                    (orderDetailItem.CouponAmount ?? 0) <
                                    orderDetailItem.TotalAmount!
                                ? "Partially Paid"
                                : "Paid"}
                            </td>{" "}
                          </>
                        ) : (
                          <></>
                        )}
                        <td>
                          <span
                            className="cursor-pointer"
                            // onClick={(e) => openOrderEventDetail(e, member)}
                            onClick={() => {
                              if (!orderDetailItem.IsGuest) {
                                console.log(
                                  "orderDetailItem:",
                                  orderDetailItem
                                );
                                setOrderEventDetailModalOpen(true);
                                if (orderDetailItem.OrderId) {
                                  getOrder(orderDetailItem.OrderId as number);
                                }
                              } else {
                                console.log(
                                  "in guestOrderDetailItem:",
                                  orderDetailItem
                                );
                                setGuestOrderEventDetailModalOpen(true);
                                if (
                                  orderDetailItem.OrderId &&
                                  orderDetailItem.IsGuest
                                ) {
                                  getOrder(
                                    orderDetailItem.OrderId as number,
                                    orderDetailItem.IsGuest
                                  );
                                }
                              }
                            }}
                          >
                            Edit
                          </span>
                        </td>
                        {/* <td>
                        {orderDetailItem.ParticipantType !== "Moderator" && (
                          <div>
                            <a title="Make as Moderator">
                              <button
                                className="event-button"
                                onClick={() =>
                                  updateModerators(orderDetailItem)
                                }
                              >
                                Make as Moderator
                              </button>
                            </a>
                          </div>
                        )}
                        {orderDetailItem.ParticipantType !== "Speaker" && (
                          <div>
                            <a title="Make as Speaker">
                              <button
                                className="event-button"
                                onClick={() => updateSpeakers(orderDetailItem)}
                              >
                                Make as Speaker
                              </button>
                            </a>
                          </div>
                        )}
                        {orderDetailItem.ParticipantType !== "Attendee" && (
                          <div>
                            <a title="Make as Attendee">
                              <button
                                className="event-button"
                                onClick={() => updateAttendees(orderDetailItem)}
                              >
                                Make as Attendee
                              </button>
                            </a>
                          </div>
                        )}
                      </td> */}
                        {/* <td className="text-center">
                      <input
                        type="checkbox"
                        name="attendee"
                        onChange={() => handleCheck(orderDetailItem)}
                      />
                    </td> */}
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div>--</div>
        )}
      </div>

      <ReactModal
        isOpen={markAttendanceModalOpen}
        onRequestClose={() => setMarkAttendanceModalOpen(false)}
        className="editinfo-modal-large"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">Mark Attendance</h1>
          <PageLink onClick={() => handleCancel()}>Close</PageLink>
        </div>
        {eventInfo.OrderDetail != null && eventInfo.OrderDetail.length > 0 ? (
          <div style={{ overflowY: "auto", width: "100%" }}>
            <table className="eventlist-table">
              <thead className="table-border">
                <tr>
                  <>
                    <th>FirstName</th>
                    <th>LastName</th>
                    <th>BarID</th>
                    <th>Attendence</th>
                    <th>DECredits</th>
                    <th>DEEnchEthics</th>
                    <th>PACredits</th>
                    <th>PAEthics</th>
                    <th>NJCredits</th>
                    <th>NJEthics</th>
                    <th>Action</th>
                  </>
                </tr>
              </thead>

              <tbody className="table-border">
                {eventInfo.OrderDetail.map(
                  (orderDetailItem: any, index: number) => (
                    <tr key={index}>
                      <>
                        <td>
                          <Tooltip title="View Profile" arrow>
                            <span
                              className="cursor-pointer"
                              style={{ color: "black" }}
                              onClick={() => viewMember(orderDetailItem)}
                            >
                              {orderDetailItem.FirstName}
                            </span>
                          </Tooltip>
                        </td>
                        <td>
                          <Tooltip title="View Profile" arrow>
                            <span
                              className="cursor-pointer"
                              style={{ color: "black" }}
                              onClick={() => viewMember(orderDetailItem)}
                            >
                              {orderDetailItem.LastName}
                            </span>
                          </Tooltip>
                        </td>
                        <td>
                          <Tooltip title="View Profile" arrow>
                            <span
                              className="cursor-pointer"
                              style={{ color: "black" }}
                              onClick={() => viewMember(orderDetailItem)}
                            >
                              {orderDetailItem.BarId}
                            </span>
                          </Tooltip>
                        </td>
                        <td>
                          {/* {orderDetailItem.IsAttended == false ? (
                            <span>Pending update</span>
                          ) : orderDetailItem.IsAttended == true ? (
                            <span style={{ color: "green" }}>Attended</span>
                          ) : (
                            <span style={{ color: "red" }}>Absent</span>
                          )} */}
                          <div className="checkboxgroup-buttons">
                            <input
                              id={orderDetailItem.Id}
                              className="checkbox-find"
                              name={orderDetailItem.Id}
                              checked={
                                orderDetailItem.IsAttendenceUpdated === 1
                                    ? orderDetailItem.IsAttended === 1
                                    : false
                              }
                              disabled={
                                orderDetailItem.IsAttendenceUpdated === 0
                                  ? false
                                  : orderDetailItem.IsAttendenceInEditMode === 1
                                  ? false
                                  : true
                              }
                              type="radio"
                              onChange={(e) => setIsAttended(e, 1, index)}
                            />
                            <span style={{ marginRight: "0.5rem" }}>Yes</span>
                            <input
                              id={orderDetailItem.Id}
                              className="checkbox-find"
                              name={orderDetailItem.Id}
                              type="radio"
                              disabled={
                                orderDetailItem.IsAttendenceUpdated === 0
                                  ? false
                                  : orderDetailItem.IsAttendenceInEditMode === 1
                                  ? false
                                  : true
                              }
                              checked={
                                orderDetailItem.IsAttendenceUpdated === 1
                                  ? orderDetailItem.IsAttended === 0
                                  : false
                              }
                              onChange={(e) => setIsAttended(e, 0, index)}
                            />
                            <span
                              style={{
                                marginRight: "0.5rem",
                                width: "60px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              No
                            </span>
                          </div>
                        </td>
                        <td>
                          <div
                            className="input-field-div-wrapper-intable align-item-vcenter"
                            style={{ marginBottom: "0px", height: "30px" }}
                          >
                            <input
                              className="input-field-div-small"
                              style={{ height: "auto", marginBottom: "0px" }}
                              id="DECredits"
                              name="DECredits"
                              onChange={(e) => {
                                updateAttendance(e, index);
                              }}
                              value={
                                (orderDetailItem.DECredits ?? eventInfo.DECredits ?? "") + ""
                              }
                              disabled={
                                orderDetailItem.IsAttendenceUpdated === 0
                                  ? false
                                  : orderDetailItem.IsAttendenceInEditMode === 1
                                  ? false
                                  : true
                              }
                              autoComplete="off"
                            />
                            {/* <label className="form-label" htmlFor="BarId">
                              DECredits
                            </label> */}
                          </div>
                        </td>
                        <td>
                          <div
                            className="input-field-div-wrapper-intable"
                            style={{ marginBottom: "0px", height: "30px" }}
                          >
                            <input
                              className="input-field-div-small"
                              style={{ height: "auto", marginBottom: "0px" }}
                              id="DEEnchEthics"
                              name="DEEnchEthics"
                              onChange={(e) => {
                                updateAttendance(e, index);
                              }}
                              value={
                                (orderDetailItem.DEEnchEthics ?? eventInfo.DEEnchEthics ?? "") + ""
                              }
                              disabled={
                                orderDetailItem.IsAttendenceUpdated === 0
                                  ? false
                                  : orderDetailItem.IsAttendenceInEditMode === 1
                                  ? false
                                  : true
                              }
                              autoComplete="off"
                            />
                            {/* <label className="form-label" htmlFor="BarId">
                              DEEnchEthics
                            </label> */}
                          </div>
                        </td>
                        <td>
                          <div
                            className="input-field-div-wrapper-intable"
                            style={{ marginBottom: "0px", height: "30px" }}
                          >
                            <input
                              className="input-field-div-small"
                              style={{ height: "auto", marginBottom: "0px" }}
                              id="PACredits"
                              name="PACredits"
                              onChange={(e) => {
                                updateAttendance(e, index);
                              }}
                              value={
                                (orderDetailItem.PACredits ?? eventInfo.PACredits ?? "") + ""
                              }
                              disabled={
                                orderDetailItem.IsAttendenceUpdated === 0
                                  ? false
                                  : orderDetailItem.IsAttendenceInEditMode === 1
                                  ? false
                                  : true
                              }
                              autoComplete="off"
                            />
                            {/* <label className="form-label" htmlFor="BarId">
                              PACredits
                            </label> */}
                          </div>
                        </td>
                        <td>
                          <div
                            className="input-field-div-wrapper-intable"
                            style={{ marginBottom: "0px", height: "30px" }}
                          >
                            <input
                              className="input-field-div-small"
                              style={{ height: "auto", marginBottom: "0px" }}
                              id="PAEthics"
                              name="PAEthics"
                              onChange={(e) => {
                                updateAttendance(e, index);
                              }}
                              value={
                                (orderDetailItem.PAEthics ?? eventInfo.PAEthics ?? "") + ""
                              }
                              disabled={
                                orderDetailItem.IsAttendenceUpdated === 0
                                  ? false
                                  : orderDetailItem.IsAttendenceInEditMode === 1
                                  ? false
                                  : true
                              }
                              autoComplete="off"
                            />
                          </div>
                        </td>
                        <td className="">
                          <div className="horizontal-wrapper-spacebetween">
                            <input
                              type="number"
                              step="0.1"
                              min="0"
                              max="50"
                              className="form-control"
                              style={{
                                width: "90px",
                                height: "30px",
                                fontSize: "small",
                              }}
                              id="NJCredits"
                              name="NJCredits"
                              placeholder=""
                              onChange={(e) => {
                                updateAttendance(e, index);
                              }}
                              value={
                                (orderDetailItem.NJCredits ?? eventInfo.NJCredits ?? "") + ""
                              }
                              disabled={
                                orderDetailItem.IsAttendenceUpdated === 0
                                  ? false
                                  : orderDetailItem.IsAttendenceInEditMode === 1
                                  ? false
                                  : true
                              }
                              autoComplete="off"
                            />
                            <label
                              className="form-label-underlined"
                              htmlFor="NJCredits"
                            >
                              NJCredits
                            </label>
                          </div>
                        </td>
                        <td className="">
                          <div className="horizontal-wrapper-spacebetween">
                            <input
                              type="number"
                              step="0.1"
                              min="0"
                              max="50"
                              className="form-control"
                              style={{
                                width: "90px",
                                height: "30px",
                                fontSize: "small",
                              }}
                              id="NJEthics"
                              name="NJEthics"
                              placeholder=""
                              onChange={(e) => {
                                updateAttendance(e, index);
                              }}
                              value={
                                (orderDetailItem.NJEthics ?? eventInfo.NJEthics ?? "") + ""
                              }
                              disabled={
                                orderDetailItem.IsAttendenceUpdated === 0
                                  ? false
                                  : orderDetailItem.IsAttendenceInEditMode === 1
                                  ? false
                                  : true
                              }
                              autoComplete="off"
                            />
                            <label
                              className="form-label-underlined"
                              htmlFor="NJEthics"
                            >
                              NJEthics
                            </label>
                          </div>
                        </td>
                        <td className="text-center">
                          {
                            orderDetailItem.IsAttendenceInEditMode === 0 &&
                            orderDetailItem.IsAttendenceUpdated === 1 ? (
                              <SecondaryWhiteButton
                                className="button-wrapper"
                                type="button"
                                onClick={() => {
                                  const eventDetailBodyType: EventDetailBodyType =
                                    {
                                      key: "IsAttendenceInEditMode",
                                      value: 1,
                                      index: index,
                                    };
                                  dispatch(
                                    updateOrderDetail(eventDetailBodyType)
                                  );
                                  // setIsAttendedFlag(true);
                                }}
                              >
                                <span style={{ fontWeight: "500" }}>Edit</span>
                              </SecondaryWhiteButton>
                            ) : (
                              // orderDetailItem.IsAttendenceUpdated == 1 ?
                              <SecondaryBlueButton
                                className="button-wrapper"
                                type="button"
                                onClick={() => submitAttendance(index)}
                                disabled={!(orderDetailItem.IsAttendenceUpdated === 1)}
                              >
                                <span style={{ fontWeight: "500" }}>
                                  Submit
                                </span>
                              </SecondaryBlueButton>
                            )
                            // : (
                            //   <SecondaryBlueButton
                            //     className="button-wrapper"
                            //     type="button"
                            //     onClick={() => submitAttendance(index)}
                            //     // disabled={ orderDetailItem.isAttendedFlag ? }
                            //   >
                            //     <span style={{ fontWeight: "500" }}>Submit1</span>
                            //   </SecondaryBlueButton>
                            // )
                          }
                        </td>
                      </>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </div>
        ) : (
          <div>--</div>
        )}
      </ReactModal>

      <ReactModal
        isOpen={addMemberModelOpen}
        onRequestClose={() => setAddMemberModalOpen(false)}
        className="editinfo-modal-large"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading"> Add Member</h1>
          <PageLink onClick={() => handleCancel()}>Close</PageLink>
        </div>
        <EventFindMember
          callCloseAddMemberModel={() => setAddMemberModalOpen(false)}
        />
      </ReactModal>

      <ReactModal
        isOpen={orderEventDetailModalOpen}
        onRequestClose={() => setOrderEventDetailModalOpen(false)}
        className="editinfo-modal-large overflow-auto"
        overlayClassName="overlay-dark"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading" style={{ marginBottom: "2rem" }}>
            Update Cost and Payment Information
          </h1>
          <PageLink
            onClick={() => {
              setOrderEventDetailModalOpen(false);
            }}
            style={{ marginBottom: "2rem" }}
          >
            Close
          </PageLink>
        </div>
        {orderInfoSetFlag === true ? (
          <EventMemberPaymentInfo
            member={member!}
            callOrderAPI={callUpdateOrderAPI}
            closeModal={() => setOrderEventDetailModalOpen(false)}
            // orderType={eventInfo.EventType!} // Seminar, Function, Video
          />
        ) : (
          <h3>Loading...</h3>
        )}
      </ReactModal>

      <ReactModal
        isOpen={addGuestModelOpen}
        onRequestClose={() => setAddGuestModalOpen(false)}
        className="editinfo-modal-large"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading"> Add Guest</h1>
          <PageLink onClick={() => handleCancel()}>Close</PageLink>
        </div>
        <EventAddGuest callOrderAPI={callCreateGuestOrderAPI} />
      </ReactModal>

      <ReactModal
        isOpen={guestOrderEventDetailModalOpen}
        onRequestClose={() => setGuestOrderEventDetailModalOpen(false)}
        className="editinfo-modal-large overflow-auto"
        overlayClassName="overlay-dark"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading" style={{ marginBottom: "2rem" }}>
            Update Guest Information
          </h1>
          <PageLink
            onClick={() => {
              setGuestOrderEventDetailModalOpen(false);
              dispatch(storeResetGuestOrder());
            }}
            style={{ marginBottom: "2rem" }}
          >
            Close
          </PageLink>
        </div>
        {orderInfoSetFlag === true ? (
          <EventAddGuest
            callOrderAPI={callUpdateGuestOrderAPI}
            operationType="EDIT"
            closeModal={() => {
              setOrderEventDetailModalOpen(false);
              setGuestOrderEventDetailModalOpen(false);
            }}
          />
        ) : (
          <h3>Loading...</h3>
        )}
        {/* {orderInfoSetFlag === true ? (
          <EventMemberPaymentInfo
            member={member!}
            callOrderAPI={callUpdateOrderAPI}
            closeModal={() => setOrderEventDetailModalOpen(false)}
            // orderType={eventInfo.EventType!} // Seminar, Function, Video
          />
        ) : (
          <h3>Loading...</h3>
        )} */}
      </ReactModal>

      <ReactModal
        isOpen={viewFuncAttendanceReportModalOpen}
        onRequestClose={() => setViewFuncAttendanceReportModalOpen(false)}
        className="editinfo-modal-large overflow-auto"
        overlayClassName="overlay-dark"
      >
        {/* <div className="horizontal-wrapper-spacebetween">
          <div className="d-none d-lg-block">
            <img className="logo-img " src={DSBAlogo} alt="DSBA" />
          </div>
          <h1 className="page-heading" style={{ marginBottom: "2rem" }}>
            Attendance Report
          </h1>
          <div>Event Name:</div>
          <PageLink
            onClick={() => {
              setGuestOrderEventDetailModalOpen(false);
              dispatch(storeResetGuestOrder());
            }}
            style={{ marginBottom: "2rem" }}
          >
            Close
          </PageLink>
        </div> */}

        <FuncAttendanceReport
          callBackClose={() => setViewFuncAttendanceReportModalOpen(false)}
        />
      </ReactModal>

      <ReactModal
        isOpen={viewCLEAttendanceReportModalOpen}
        onRequestClose={() => setViewCLEAttendanceReportModalOpen(false)}
        className="editinfo-modal-large overflow-auto"
        overlayClassName="overlay-dark"
      >
        <CLEAttendanceReport
          callBackClose={() => setViewCLEAttendanceReportModalOpen(false)}
        />
      </ReactModal>

      {/* COMMISSION REPORT */}
      <ReactModal
        isOpen={viewCommissionReportModalOpen}
        onRequestClose={() => setViewCommissionReportModalOpen(false)}
        className="editinfo-modal-large overflow-auto"
        overlayClassName="overlay-dark"
      >
        {eventInfo.EventType ? (
          <CommissionReport
            reportType={eventInfo.EventType}
            callBackClose={() => setViewCommissionReportModalOpen(false)}
          />
        ) : (
          <></>
        )}
      </ReactModal>
      <ReactModal
        isOpen={viewInvoiceModalOpen}
        onRequestClose={() => {
          setViewInvoiceModalOpen(false);
        }}
        className="editinfo-modal"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">View INVOICE</h1>
          <div className="d-flex" style={{ width: "30%" }}>
            <div className="secondary-button">
              <Button
                type="submit"
                onClick={() => {
                  setViewInvoiceModalOpen(false);
                }}
              >
                Close
              </Button>
            </div>
            <div className="secondary-button">
              <Button type="submit" onClick={handleSendInvoice}>
                Email Invoice
              </Button>
            </div>
          </div>
            <div className="pdf-container">
            <iframe title="Invoice Preview" src={invoiceURL} allow="autoplay" loading="lazy"></iframe>
          </div>
        </div>
      </ReactModal>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
      {isDataLoading ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.4)", // semi-transparent black
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1300, // high enough to overlay everything
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
export default ParticipantList;
